import { Component } from 'react';
import { UtilsService } from '../../services/UtilsService';
import { HttpRequestService } from '../../services/HttpRequestService';
import Pagination from '../../common/Pagination';
import { Link } from "react-router-dom";
import moment from 'moment'

class MassOrders extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            massOrders: [],
            pageCount: 0,
            pageIndex: 0
        }
        this.paramsKey = "params.mass-orders-log";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handlePageChange = this.handlePageChange.bind(this);
        this.pageSize = 50;
        this.getMassOrders = this.getMassOrders.bind(this);
    }

    componentDidMount() {
        this.getMassOrders(this.state.pageIndex);
    }

    handlePageChange(page) {
        this.getMassOrders(page);
    }

    getMassOrders(page) {
        this.setState({ pageIndex: page });
        var params = {
            status: this.state.status,
            pageSize: this.pageSize,
            pageIndex: page
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Orders/GetMassOrders', params).then(data => {
            this.setState({ massOrders: data.data, pageCount: parseInt(Math.ceil(data.count / this.pageSize)) });
        });
    }

    revertMassOrder(massOrder) {
        this.utils.confirm("Orders created through this mass operation will be deleted. Are you sure?", () => {
            var params = {
                id: massOrder.massOrderId
            }
            this.http.get('/api/Orders/RevertMassOrder', params).then(data => {
                this.utils.info("It will take some time to undo the mass order creation. You will receive an email once the process is complete.");
                this.getMassOrders(0);
            });
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Mass Orders Log</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-row">
                                    <table className="table table-striped mt-1">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th scope="col">Created by</th>
                                                <th scope="col">Status</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.massOrders.map((massOrder) =>
                                                <tr key={massOrder.massOrderID}>
                                                    <td><Link to={"/orders/mass-order/" + massOrder.massOrderId}>{moment(massOrder.timestamp).format("l")}</Link></td>
                                                    <td>{massOrder.username}</td>
                                                    <td>{massOrder.status}</td>
                                                    <td>
                                                        {massOrder.status === "completed" &&
                                                            <button className="btn btn-sm btn-info" onClick={e => this.revertMassOrder(massOrder)}>Revert <i className="fas fa-undo"></i></button>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.massOrders.length > 0 &&
                                            <Pagination pageIndex={this.state.pageIndex} pageCount={this.state.pageCount} onPageChanged={this.handlePageChange}></Pagination>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MassOrders;
